import { render } from "./ArrowBottomRightIcon.vue?vue&type=template&id=2bf5d886"
import script from "./ArrowBottomRightIcon.vue?vue&type=script&lang=js"
export * from "./ArrowBottomRightIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__